import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { deleteFieldAction, editFieldAction, fieldListAction } from "../../../../../../modules/fields/action";
import TabHeaderAndButton from "../../../../../Common/TabHeaderAndButton";
import CreateTable from "../../../../../CreateTable";
import ConfirmationDialog from "../../../../../FormElement/ConfirmationDialog";
import Loader from "../../../../../Loader";


class FieldView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetchingComplete: false,
      headerRows: {
        updatedAt: "Last Updated",
        updatedBy: "Updated By",
        name: "Fields",
        legalDescription: "Legal Description"
      },
      order: "desc",
      orderBy: "id",
      open: false
    };
  }

  componentDidMount() {
    const id = localStorage.getItem("currentFieldGrpId");
    const { fieldListAction, selectedYear, selectedGrp } = this.props;
    fieldListAction(id , selectedYear, selectedGrp.id);
    console.log(selectedGrp.id,'se;e')
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.fieldLst &&
      this.props.fieldLst !== nextProps.fieldLst &&
      this.state.fetchingComplete === false
    ) {
      this.setState({ fetchingComplete: true });
    } else if (
      nextProps.ErrorMessage &&
      this.props.ErrorMessage !== nextProps.ErrorMessage
    ) {
      this.setState({ fetchingComplete: true });
    }
    const id = localStorage.getItem("currentFieldGrpId");

    if (nextProps.selectedYear && nextProps.selectedYear !== this.props.selectedYear) {
      this.props.fieldListAction(id, nextProps.selectedYear, this.props.selectedGrp.id);
    }
  }

  deleteRow = id => {
    this.setState({
      open: true,
      id: id
    });
  };

  handleClose = () => {
    this.setState({
      open: false
    });
  };

  handleOk = () => {
    const { id } = this.state;
    this.handleClose();
    this.props.deleteFieldAction(id);
  };

  editRow = id => {
    const { fieldLst } = this.props;
    const requiredData = fieldLst.find(field => field.id === id);
    console.log(requiredData);
    this.props.editFieldAction(requiredData);
  };

  handleRequestSort = (event, property) => {
    const isDesc =
      this.state.orderBy === property && this.state.order === "desc";
    this.setState({
      order: isDesc ? "asc" : "desc",
      orderBy: property
    });
  };

  render() {
    const { fieldLst } = this.props;
    const { fetchingComplete, order, orderBy, open } = this.state;
    const prevPath = "farmsetup/farminformation/field-groups",
      currentPage = "/fields";
    return (
      <div className="ticket-body">
        <ConfirmationDialog
          open={open}
          handleClose={this.handleClose}
          handleOk={this.handleOk}
        />
        <TabHeaderAndButton
          header="Fields"
          path={`/${prevPath}${currentPage}/create`}
          btnLabel="Add field"
        />
        <div>
          {fetchingComplete ? (
            <CreateTable
              order={order}
              orderBy={orderBy}
              headerRows={this.state.headerRows}
              rowData={fieldLst}
              delete={this.deleteRow}
              location={`${prevPath}${currentPage}/edit`}
              edit={this.editRow}
              onRequestSort={this.handleRequestSort}
            />
          ) : (
            <Loader />
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    fieldLst: state.fieldReducer.fieldList,
    ErrorMessage: state.globalserverMessage.ErrorMessage,
    selectedYear: state.harvestYearReducer.selectedYear,
    selectedGrp: state.fieldGroupReducer.selectedGrp,
  };
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    { fieldListAction, deleteFieldAction, editFieldAction },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FieldView);



// WEBPACK FOOTER //
// ./src/components/private/FarmInformation/parts/FieldGroups/Fields/FieldView.js